<div class="alert_title" mat-dialog-title>{{ 'AreYouSureYouWantToDeleteThisCategory' | translate}}</div>
<div mat-dialog-actions>
  <button class="alert_delete_btn" (click)="deleteFromCategories()">{{'Delete' | translate}}</button>
  <button class="alert_cancel_btn" (click)="closeDialog()">{{'Cancellation' | translate}}</button>
</div>
